import { useNavigate } from "react-router-dom";
import "./dashboard_side_bar.css"
import { FaAngleRight } from "react-icons/fa6";


const DashboardSideBar = ({setCurrentDashText,isSideNav, setIsSideNav,setSubText,subText}) =>{

    const navigate = useNavigate();

    const route = 
        [{
            name: "Overview",
            id: 1
        },
        {
            name: "Financials",
            id: 2
        },
        {
            name: "Supplements",
            id: 3
        },
        {
            name: "Reits",
            id: 4
        },
        { 
            name: "Indexes",
            id: 5
        },
        /*{
            name: "ETFs",
            id: 6
        },*/
    
        ]

    const handleLogout = () => {
        navigate("/login");
      };


      const navChange = (index,name) => {
        setCurrentDashText(name);
        let currentState = [true,false,false,false,false,false]

        //Route to different page
        switch(index){
            case 0:
                currentState = [true,false,false,false,false,false]
                setSubText('setup');
                break;
            case 1:
                currentState = [false,true,false,false,false,false]
                setSubText('get_balance_sheet');
                break;
            case 2:
                currentState = [false,false,true,false,false,false]
                setSubText('get_cpi');
                break;
            case 3:
                currentState = [false,false,false,true,false,false]
                setSubText('ten_year_treasury');
                break;
            case 4:
                currentState = [false,false,false,false,true,false]
                setSubText('sp_500_index');
                break
            case 5:
                currentState = [false,false,false,false,false,true]
                setSubText('get_all_etf');
                break;
            default:
                currentState = [true,false,false,false,false,false]
                setSubText('setup');
                break;

        }
        setIsSideNav(currentState);
    }



    return(
        <div className="api_sidebar">
            <div className="api_routes_container">
                {
                    route.map(((route,index) =>
                        <button onClick={() => navChange(index,route.name)} className={isSideNav[index]?"api_route_item-active":"api_route_item"}>
                            
                         <FaAngleRight />  {route.name}</button>
                    ))
                }
            </div>
            <div className="api_routes_botton_container">
                <div className="nav-section-api-login-outer">
                    <div className="nav-section-api-login-inner">
                        <button onClick={handleLogout} className="api_button">
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardSideBar;